import { Grid, List } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { clsJoin } from '@/utils'
import type { ProjectsView } from '../../types'
import css from './styles.module.css'

interface Props {
  value: ProjectsView
  onChange: (view: ProjectsView) => void
}

// Tiles or rows. Sits next to the sort select above the projects list.
export const ViewSwitcher: React.FC<Props> = ({ value, onChange }) => {
  const grid = value === 'grid'
  const list = value === 'list'

  return (
    <div
      className={clsJoin(css.switcher, list && css.list)}
      role="group"
      aria-label="Projects view"
    >
      <button
        type="button"
        className={clsJoin(css.item, grid && css.active)}
        aria-label="Grid view"
        aria-pressed={grid}
        title="Grid view"
        onClick={() => onChange('grid')}
      >
        <Grid />
      </button>
      <button
        type="button"
        className={clsJoin(css.item, list && css.active)}
        aria-label="List view"
        aria-pressed={list}
        title="List view"
        onClick={() => onChange('list')}
      >
        <List />
      </button>
    </div>
  )
}
